import { ReportRange } from '../../../../utils/report-range';
import { formatDateTime, formatDay, pad, ReportRowVm } from './report-row.view-model';

// As Polish Excel opens a file by double-click: UTF-8 with a byte-order mark, ; between
// fields, CRLF line ends, a decimal comma in Ilość, text fields quoted
const BYTE_ORDER_MARK = '﻿';
const SEPARATOR = ';';
const LINE_END = '\r\n';

/**
 * The table's column names, in the table's order — plus Nazwa zlecenia, which the table
 * shows as the number's tooltip and the file as a column of its own (0109).
 */
export const REPORT_CSV_COLUMNS = [
  'Data i godzina',
  'Zgłosił',
  'Zlecenie',
  'Nazwa zlecenia',
  'Pozycja',
  'Do',
  'Produkt końcowy',
  'Etap',
  'Ilość',
  'Jedn.',
  'Kończy pozycję'
];

/**
 * The exported file: a stamp row saying when it was taken and what it covers, the header,
 * then the rows — same order and same values as on screen. Pure, so it can be read and
 * tested without a browser.
 */
export function buildReportCsv(rows: ReportRowVm[], range: ReportRange, exportedAt: Date): string {
  const lines = [
    ['Wyeksportowano', formatDateTime(exportedAt), 'Zakres', range.from, range.to].join(SEPARATOR),
    REPORT_CSV_COLUMNS.map(quote).join(SEPARATOR),
    ...rows.map(row => [
      quote(row.reportedAtLabel),
      quote(row.reporterLabel),
      quote(row.orderNumber),
      quote(row.orderName),
      quote(row.itemName),
      quote(row.parentLabel),
      quote(row.rootName),
      quote(row.stageLabel),
      decimalComma(row.amount),
      quote(row.unit),
      quote(row.completesLabel)
    ].join(SEPARATOR))
  ];

  return BYTE_ORDER_MARK + lines.join(LINE_END) + LINE_END;
}

/** "raporty_2026-10-01_2026-10-23_eksport_2026-10-23_1412.csv" — the stamp again, for a renamed or printed copy. */
export function reportCsvFileName(range: ReportRange, exportedAt: Date): string {
  const time = `${pad(exportedAt.getHours())}${pad(exportedAt.getMinutes())}`;

  return `raporty_${range.from}_${range.to}_eksport_${formatDay(exportedAt)}_${time}.csv`;
}

// a quote inside a field is doubled, the CSV way — shared with the Zapotrzebowanie file (0118)
export function quote(value: string): string {
  return `"${value.replace(/"/g, '""')}"`;
}

// the number as the app prints it, with Excel's Polish decimal separator
export function decimalComma(value: number): string {
  return String(value).replace('.', ',');
}
